import { render, staticRenderFns } from "./ClassroomExercisesReadingStudent.vue?vue&type=template&id=e42878b8&scoped=true&"
import script from "./ClassroomExercisesReadingStudent.vue?vue&type=script&lang=ts&"
export * from "./ClassroomExercisesReadingStudent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42878b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VProgressCircular,VSimpleTable})
